const header = [
  { text: 'tier_prize_id', value: 'tier_prize_id' },
  { text: 'skill_testing_question_id', value: 'skill_testing_question_id' }
]

export default header
